<a (click)="handleDayChange(isNextDayChanger)" class="c-ts-day-changer__btn">
    <i
        class="u-icon"
        [ngClass]="{'u-icon-angle-left': !isNextDayChanger, 'u-icon-angle-right': isNextDayChanger}"
    >
    </i>
</a>
